import { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router';
import { api } from '@/services/api';
import { removeAuthObject } from '@/utils/auth';
import { BaseFormModal } from '@/components/BaseFormModal';

export function ResetPasswordScreen() {
  const { code } = useParams<{ code: string }>();

  const [loading, setLoading] = useState(true);
  const [username, setUsername] = useState('');
  const [formVisible, setFormVisible] = useState(true);
  const [password, setPassword] = useState('');
  const [passwordRepeat, setPasswordRepeat] = useState('');
  const [resetting, setResetting] = useState(false);
  const [successOpen, setSuccessOpen] = useState(false);

  useEffect(() => {
    removeAuthObject();
    if (!code) return;
    api.getUsernameForPasswordReset(code).then(
      (result) => setUsername(result.username),
      () => {
        setUsername('Password reset code invalid or expired. Please use Forgot Password feature again to send a new email.');
        setFormVisible(false);
      }
    ).finally(() => setLoading(false));
  }, [code]);

  const submitResetPassword = useCallback(async () => {
    setResetting(true);
    try {
      await api.resetPassword({
        resetCode: code,
        newPassword1: password,
        newPassword2: passwordRepeat,
      });
      setSuccessOpen(true);
    } catch {
      // Error handled by API
    }
    setResetting(false);
  }, [code, password, passwordRepeat]);

  return (
    <>
      <BaseFormModal
        open={successOpen}
        title="Password Reset Successful"
        showCancel={false}
        saveText="Sign In"
        onSave={() => { window.location.href = '/'; }}
        onCancel={() => {}}
      >
        <p>Please click the "Sign In" button below to go to the sign in screen.</p>
      </BaseFormModal>

      <div id="divContainer" style={{ paddingLeft: 0, paddingRight: 0 }}>
        <div className="kstc-row">
          <section id="SectionSignIn" className="form-signin">
            <div className="limiter">
              <div className="container-login100">
                <div className="login100-more" style={{ backgroundImage: "url('/Content/Customize/img/login-2-v1.jpg')", zIndex: 'auto' }}></div>
                <div className="waveWrapper waveAnimation">
                  <div className="waveWrapperInner bgTop">
                    <div className="wave waveTop" style={{ backgroundImage: "url('/Content/Customize/img/Wave-top.png')" }}></div>
                  </div>
                  <div className="waveWrapperInner bgMiddle">
                    <div className="wave waveMiddle" style={{ backgroundImage: "url('/Content/Customize/img/Wave-mid.png')" }}></div>
                  </div>
                  <div className="waveWrapperInner bgBottom">
                    <div className="wave waveBottom" style={{ backgroundImage: "url('/Content/Customize/img/wave-bot.png')" }}></div>
                  </div>
                </div>
                <div className="wrap-login100">
                  <form className="login100-form validate-form p-l-50 p-r-50 p-t-72" onSubmit={(e) => { e.preventDefault(); submitResetPassword(); }}>
                    <span className="login100-form-title p-b-59">Password Reset</span>

                    {loading ? (
                      <div style={{ textAlign: 'center', padding: '20px 0' }}>
                        <span className="kstc-spinner kstc-spinner--sm"></span> Loading...
                      </div>
                    ) : (
                      <>
                    <p className="input100">{username}</p>

                    {formVisible && (
                      <>
                        <div className="wrap-input100 validate-input" data-validate="Password is required">
                          <span className="label-input100">Password</span>
                          <input className="input100" type="password" placeholder="**********" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" required />
                          <span className="focus-input100"></span>
                        </div>
                        <div className="wrap-input100 validate-input" data-validate="Password is required">
                          <span className="label-input100">Repeat password</span>
                          <input className="input100" type="password" placeholder="**********" value={passwordRepeat} onChange={(e) => setPasswordRepeat(e.target.value)} autoComplete="new-password" required />
                          <span className="focus-input100"></span>
                        </div>
                        <button type="submit" disabled={resetting} className="kstc-btn kstc-btn--primary kstc-btn--lg" style={{ width: '100%' }}>
                          {!resetting ? <span>Reset Password</span> : <span><span className="kstc-spinner kstc-spinner--sm"></span> Resetting Password...</span>}
                        </button>
                      </>
                    )}
                      </>
                    )}
                  </form>
                  <footer className="login-footer">
                    <a target="_blank" href="//kerkton.com/terms" rel="noreferrer">Terms &amp; Conditions</a> | <a target="_blank" href="//kerkton.com/privacy" rel="noreferrer">Privacy Policy</a>
                  </footer>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}
